var r,e;function n(){return e?r:(e=1,r=function(r,e){return e?r.replace(/\/+$/,"")+"/"+e.replace(/^\/+/,""):r})}export{n as __require};
